import { Component, OnInit } from '@angular/core';
import { NoticiasService } from 'src/app/services/noticias.service';
import { Noticia } from 'src/app/models/noticia.model';

@Component({
  selector: 'app-trabalhista',
  templateUrl: './trabalhista.component.html',
  styleUrls: ['./trabalhista.component.css']
})
export class TrabalhistaComponent implements OnInit {

  public noticias : Noticia[]
  
  constructor(ns: NoticiasService)
  {
      ns.getNoticiasTrabalhista()
      .subscribe((dados: Noticia[]) => this.noticias = dados);
  }
  
  ngOnInit(): void {
  }

}
